<template>
  <div id="app">
    <transition name="fade">
      <component :is="layout">
        <router-view></router-view>
      </component>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'App',
  computed: {
    layout () {
      return (this.$route.meta.layout || 'default') + '-layout'
    }
  }
}
</script>

<style>
@media (min-width: 1904px) {
  .container:not(.container--fluid) {
    max-width: 1280px;
  }
}
.v-main > div {
  overflow-x: hidden;
}

.before-opacity-0::before {
  opacity: 0 !important;
}


#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
.fade-enter-active, .fade-leave-active {
  transition: opacity .2s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
.v-data-table tbody tr.v-data-table__expanded__content {
    -webkit-box-shadow: inset 0 0px 0px 0px rgba(0,0,0,0), inset 0 0px 0px 0px rgba(0,0,0,0) !important;
    box-shadow: inset 0 0px 0px 0px rgba(0,0,0,0), inset 0 0px 0px 0px rgba(0,0,0,0) !important;
}
.v-card{
  box-shadow: 0px 10px 30px rgba(0,0,0,0.1) !important;
}

/* width */
::-webkit-scrollbar {
  width: 7px;
}

/* Track */
::-webkit-scrollbar-track {
  box-shadow: inset 0 0 5px rgba(0,0,0,0.2); 
  border-radius: 25px;
  background:white;
}
 
/* Handle */
::-webkit-scrollbar-thumb {
  background: rgb(190, 190, 190); 
  border-radius: 10px;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #6d6d6d; 
}
</style>



// WEBPACK FOOTER //
// src/App.vue